import { render, staticRenderFns } from "./QuotationRemindersModal.vue?vue&type=template&id=1a0e3956&scoped=true&"
import script from "./QuotationRemindersModal.vue?vue&type=script&lang=js&"
export * from "./QuotationRemindersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e3956",
  null
  
)

export default component.exports